export const gvsgDateFormat = 'DD.MM.YYYY';
